import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'

import { INVERSION_PAGE_TYPES } from '../../../constants'
import { useInversionData } from '../../../hooks/useInversionData'

import './ReactInversionList.scss'

const ReactInversionList = (): JSX.Element => {
  const inversionItems = useInversionData()
  const { appData } = useAppDataContext()
  const linkHref = window?.location?.pathname?.replace('.html', '')
  const pageType = appData?.page?.pageType
  const stateCounts: Record<string, { stateName: string; count: number }[]> = {}

  inversionItems?.forEach((item: any) => {
    let stateCity = ''
    let stateName = ''
    //Based on the page where its used select State or City to display
    if (
      pageType === INVERSION_PAGE_TYPES.stores ||
      pageType === INVERSION_PAGE_TYPES.communities ||
      pageType === INVERSION_PAGE_TYPES.services
    ) {
      stateCity = item?.address_state.toLowerCase()
      stateName = item?.address_statename
    } else if (
      pageType === INVERSION_PAGE_TYPES.stores_state ||
      pageType === INVERSION_PAGE_TYPES.communities_state ||
      pageType === INVERSION_PAGE_TYPES.services_state
    ) {
      stateCity = item?.address_city.toLowerCase().split(' ').join('-')
      stateName = item?.address_city
    }

    if (!stateCounts[stateCity]) {
      stateCounts[stateCity] = []
    }

    const existingEntry = stateCounts[stateCity].find((entry) => entry.stateName === stateName)

    if (existingEntry) {
      existingEntry.count++
    } else {
      stateCounts[stateCity].push({ stateName, count: 1 })
    }
  })

  const sortedStateCounts = Object.fromEntries(
    Object.entries(stateCounts)?.sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
  )

  return (
    <>
      <div className={`inversion-list`}></div>
      <div className={`inversion-list__sitemap`}>
        <div className={`container inversion-list__container`} data-testid={`inversion-list__container`}>
          <ul className={`inversion-list_items-list`}>
            {Object.entries(sortedStateCounts).map(([stateCity, stateNameCounts]) => {
              return stateNameCounts.map((entry) => (
                <li key={`${stateCity}-${entry.stateName}`} className={`inversion-list__item`}>
                  <a
                    href={`${encodeURIComponent(linkHref).replace(/%2F/g, '/')}/${encodeURIComponent(stateCity)}.html`}
                    className='inversion-list__item-link'
                  >
                    {entry.stateName}
                  </a>
                  <span className='inversion-list__item-count'>({entry.count})</span>
                </li>
              ))
            })}
          </ul>
        </div>
      </div>
    </>
  )
}

export default ReactInversionList
